var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMail = function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.24 8H4v14.5h21.24V8Z",
    stroke: "#0000B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.62 18.27 4 8h21.24L14.62 18.27ZM17.973 15.031l7.265 7.47M4 22.501l7.265-7.47",
    stroke: "#0000B4"
  })));
};
export default SvgIconMail;